export enum FeeEntityType {
    Charge = 'charge',
    Payout = 'payout',
    Invoice = 'invoice',
    CurrencyConversion = 'currency-conversion',
    ConnectedAccountCurrencyConversion = 'connected-account-currency-conversion',
    Transaction = 'transaction',
    Subscription = 'subscription',
    Refund = 'refund',
}
